import { Description, Spinner } from '@repo/ui'

import { CardGridCategory } from '@/components/CardGridCategory'

import { useQuerySystemPlaylists } from '../../playlists/playlist-queries/system-playlists/useQuerySystemPlaylists'

interface SystemPlaylistsProps {
  onPlaylistClick: (playlistId: string) => void
}

export function SystemPlaylists({ onPlaylistClick }: SystemPlaylistsProps) {
  const { data = [], isLoading } = useQuerySystemPlaylists()

  if (isLoading) return <Spinner label='Loading our playlists...' />

  return (
    <CardGridCategory
      description={<Description>Try one of our suggested playlists.</Description>}
      handleClick={onPlaylistClick}
      heading='Our Playlists'
      items={data}
    />
  )
}
